import { render, staticRenderFns } from "./PopupGenderInfo.vue?vue&type=template&id=4c2ea528"
import script from "./PopupGenderInfo.vue?vue&type=script&lang=js"
export * from "./PopupGenderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports